<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: 'auto' }"
  [styleClass]="'barcode-dialog-wrapper'"
  [header]="
    (viewMode
      ? 'sku_management.barcode.dialog.view_title'
      : initialData
        ? 'sku_management.barcode.dialog.edit_title'
        : 'sku_management.barcode.dialog.add_title'
    ) | translate
  "
  (onHide)="onCancel()"
>
  <div class="barcode-dialog p-1" [class.pointer-events-none]="viewMode">
    <!-- Form Fields -->
    <div class="space-y-4">
      <!-- Barcode Value -->
      <div>
        <label
          for="bd-barcode"
          class="block text-sm font-medium text-gray-700 mb-2"
        >
          {{ "sku_management.barcode.fields.barcode" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          pInputText
          id="bd-barcode"
          [placeholder]="
            'sku_management.barcode.placeholders.enter_barcode' | translate
          "
          [(ngModel)]="formData.barcodeValue"
          class="w-full"
          [class.border-red-300]="showErrors() && !formData.barcodeValue"
          [disabled]="viewMode"
        />
        @if (showErrors() && !formData.barcodeValue) {
          <p class="text-red-500 text-xs mt-1">
            {{
              "sku_management.barcode.validation.barcode_required" | translate
            }}
          </p>
        }
      </div>

      <!-- Barcode Type -->
      <div>
        <label
          for="bd-barcode-type"
          class="block text-sm font-medium text-gray-700 mb-2"
        >
          {{ "sku_management.barcode.fields.barcode_type" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-select
          [options]="barcodeTypeOptions"
          optionLabel="label"
          optionValue="value"
          inputId="bd-barcode-type"
          [placeholder]="
            'sku_management.barcode.placeholders.select_barcode_type'
              | translate
          "
          [(ngModel)]="formData.barcodeType"
          styleClass="w-full"
          [disabled]="viewMode"
          appendTo="body"
        />
        @if (showErrors() && !formData.barcodeType) {
          <p class="text-red-500 text-xs mt-1">
            {{
              "sku_management.barcode.validation.barcode_type_required"
                | translate
            }}
          </p>
        }
      </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-200">
      @if (!viewMode) {
        <app-button
          [label]="'common.actions.cancel' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
        ></app-button>
        <app-button
          [label]="'common.actions.save' | translate"
          type="info"
          (emitOnClick)="onConfirm()"
        ></app-button>
      } @else {
        <app-button
          [label]="'common.actions.close' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
        ></app-button>
      }
    </div>
  </div>
</p-dialog>
